import { Button } from 'primereact/button'
import React, { useEffect, useState } from 'react'
import { Sign } from '../../shared/component/Sign';
import { Menubar } from 'primereact/menubar';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { StatementInvoiceService } from '../xu-ly-sai-sot/StatementInvoiceService';
import { getLawBases } from '../../utils/statementHelper';
import moment from 'moment';
import { LanguageSwitcher } from '../../shared/language/LanguageSwitcher';
import { useTranslation } from '../../shared/language';

const HDDT = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [doc, setDoc] = useState(null);
  const invoiceListNumber =
    doc?.invoiceListNumber ||
    doc?.relatedInvoiceListNumber ||
    doc?.statementNumber;
  const invoiceListDate =
    doc?.invoiceListDate || doc?.relatedInvoiceListDate || doc?.statementDate;
  const isMultipleInvoiceStatement = invoiceListNumber || invoiceListDate;


  const form = doc?.invoiceSerial?.substring(0, 1);
  const serial = doc?.invoiceSerial?.substring(1);
  const invoiceNumber = doc?.invoiceNumber;
  const invoiceDate = doc?.invoiceDate
    ? moment(doc.invoiceDate).format("DD/MM/YYYY")
    : "";

  console.log("doc", doc);
  console.log("serial", serial);
  console.log("form", form);
  console.log("invoiceNumber", invoiceNumber);

  useEffect(() => {
    StatementInvoiceService.getDetail(id, {
      taxCode: searchParams.get("taxCode"),
    }).then((res) => {
      setDoc(res);
    });
  }, []);

  return (
    <>
      <div className="layout-topbar justify-content-between">
        <Link to="/" className="layout-topbar-logo">
          <img
            src={"assets/layout/images/LogoAppMinvoice_new.png"}
            alt={t("common.logo")}
          />
        </Link>

        <Menubar
          model={[
            {
              label: t("common.products"),
              items: [
                {
                  label: t("common.electronicSocialInsurance"),
                  command: () => {
                    window.open("https://minvoice.vn/", "_blank");
                  },
                },
                {
                  label: t("common.invoiceRiskManagement"),
                  command: () => {
                    window.open("https://minvoice.vn/", "_blank");
                  },
                },

                {
                  label: t("common.electronicContract"),
                  command: () => {
                    window.open("https://minvoice.vn/", "_blank");
                  },
                },
              ],
            },
            {
              label: t("common.purchases"),
              command: () => {
                window.open("https://minvoice.vn/dang-ky-su-dung/", "_blank");
              },
            },
            {
              label: t("common.registerAgent"),
              command: () => {
                window.open(
                  "https://minvoice.vn/dang-ky-dai-ly-hoa-don-dien-tu/",
                  "_blank",
                );
              },
            },
          ]}
          className="app-menu"
        />
        <LanguageSwitcher publicPage />
      </div>
      <div className="layout-main-container">
        <div className="layout-main">
          <div className="w-full flex flex-column align-items-center justify-content-center gap-2 pb-8">
            <div className="flex flex-column align-items-center w-7 bg-white p-6 border-round">
              <b>{t("common.republicTitle")}</b>
              <b>{t("common.nationalMotto")}</b>
              <br />
              <br />
              <b>
                {t("common.statementTitle", {
                  action:
                    doc?.documentType === 2
                      ? t("common.adjustment")
                      : t("common.replacement"),
                })}
              </b>
              <br />
              <b>{t("common.statementNumber")}: {doc?.documentNo}</b>
              <br />
              <div className="flex flex-column gap-2">
                {getLawBases(doc?.documentDate).map((base, idx) => (
                  <i key={idx}>- {base}</i>
                ))}
              </div>
              <div className="grid">
                <p className="col-12">
                  {doc?.documentDate
                    ? (() => {
                        const d = moment(doc.documentDate);
                        return t("common.statementToday", {
                          day: d.format("DD"),
                          month: d.format("MM"),
                          year: d.format("YYYY"),
                        });
                      })()
                    : t("common.parties")}
                </p>
                <b className="col-12">
                  {t("common.seller")}: {doc?.sellerLegalName}
                </b>
                <p className="col-2">{t("common.address")}:</p>
                <p className="col-10">{doc?.sellerAddress}</p>
                <p className="col-2">{t("common.taxCode")}:</p>
                <p className="col-4">{doc?.sellerTaxCode}</p>
                <p className="col-1">{t("common.representative")}:</p>
                <p className="col-5">{doc?.sellerPersonContact}</p>
                <p className="col-2">{t("common.phone")}:</p>
                <p className="col-4">{doc?.sellerTel}</p>
                <p className="col-1">{t("common.position")}:</p>
                <p className="col-5">{doc?.sellerPosition}</p>
                <b className="col-12">{t("common.buyer")}: {doc?.buyerLegalName}</b>
                <p className="col-2">{t("common.address")}:</p>
                <p className="col-10">{doc?.buyerAddress}</p>
                <p className="col-2">{t("common.householdTaxOrCitizenId")}:</p>
                <p className="col-4">{doc?.buyerTaxCode}</p>
                <p className="col-1">{t("common.representative")}:</p>
                <p className="col-5">{doc?.buyerPersonContact}</p>
                <p className="col-2">{t("common.phone")}:</p>
                <p className="col-4">{doc?.buyerTel}</p>
                <p className="col-1">{t("common.position")}:</p>
                <p className="col-5">{doc?.buyerPosition}</p>
                <p className="col-12">
                  {isMultipleInvoiceStatement ? (
                    <i>{t("common.statementMultipleSentence", {
                      action:
                        doc?.documentType === 2
                          ? t("common.adjustment")
                          : t("common.replacement"),
                      listNumber: invoiceListNumber || "....",
                      listDate: invoiceListDate
                        ? moment(invoiceListDate).format("DD/MM/YYYY")
                        : "....",
                    })}</i>
                  ) : (
                    <>{t("common.statementSingleSentence", {
                      action:
                        doc?.documentType === 2
                          ? t("common.adjustment")
                          : t("common.replacement"),
                      form,
                      serial,
                      number: invoiceNumber,
                      date: invoiceDate,
                    })}</>
                  )}
                </p>
                {/* <b className="col-3">
                  Hóa đơn bị{" "}
                  {doc?.documentType === 2 ? "điều chỉnh" : "thay thế"}:
                </b>
                <p className="col-9">
                  Mẫu số <b>{doc?.invoiceSerial.substring(0, 1)}</b>, ký hiệu{" "}
                  <b>
                    {doc?.invoiceSerial.substring(1, doc?.invoiceSerial.length)}
                  </b>
                  , số <b>{doc?.invoiceNumber}</b>, ngày{" "}
                  <b>{moment(doc?.invoiceDate).format("DD/MM/YYYY")}</b>
                </p> */}
                <b className="col-3">
                  {t("common.reason")} {doc?.documentType === 2 ? t("common.adjustment") : t("common.replacement")}:
                </b>
                <p className="col-9">{doc?.reason}</p>
                <p className="col-12">{t("common.statementActionCommitment", {
                  action:
                    doc?.documentType === 2
                      ? t("common.adjustment")
                      : t("common.replacement"),
                })}</p>
                <div className="col-6 flex flex-column align-items-center">
                  <b>{t("common.representativeSeller")}</b>
                  <i>{t("common.digitalSignature")}</i>
                  <br />
                  {doc?.status === 2 ? (
                    <div className="grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9">
                      <span className="col-12">{t("common.signatureValid")}</span>
                      <span className="col-3">{t("common.signedBy")}</span>
                      <span className="col-9">{doc?.sellerLegalName}</span>
                      <span className="col-3">{t("common.signedDate")}</span>
                      <span className="col-9">
                        {moment(doc?.dateSign).format("DD/MM/YYYY HH:mm:ss")}
                      </span>
                      <img
                        className="col-2 absolute"
                        style={{
                          top: "60%",
                          right: "10px",
                          transform: "translateY(-50%)",
                        }}
                        src={"assets/layout/images/check.png"}
                        alt=""
                      />
                    </div>
                  ) : (
                    <Button
                      className="p-button-secondary"
                      label={t("common.sign")}
                      icon="pi pi-user-edit"
                      onClick={() => {
                        Sign({
                          CommandName: "StatementInvoice",
                          taxCode: searchParams.get("taxCode"),
                          Id: doc?.id,
                          InvoiceIdArray: [doc?.id],
                        }).then(() => {
                          StatementInvoiceService.getDetail(id, {
                            taxCode: searchParams.get("taxCode"),
                          }).then((res) => {
                            setDoc(res);
                          });
                        });
                      }}
                    />
                  )}
                </div>
                <div className="col-6 flex flex-column align-items-center">
                  <b>{t("common.representativeBuyer")}</b>
                  <i>{t("common.digitalSignature")}</i>
                  <br />
                  {doc?.buyerStatus === 2 ? (
                    <div className="grid grid-nogutter relative border-2 border-solid border-green-500 text-green-500 px-4 w-9">
                      <span className="col-12">{t("common.signatureValid")}</span>
                      <span className="col-3">{t("common.signedBy")}</span>
                      <span className="col-9">{doc?.buyerLegalName}</span>
                      <span className="col-3">{t("common.signedDate")}</span>
                      <span className="col-9">
                        {moment(doc?.buyerDateSign).format(
                          "DD/MM/YYYY HH:mm:ss",
                        )}
                      </span>
                      <img
                        className="col-2 absolute"
                        style={{
                          top: "60%",
                          right: "10px",
                          transform: "translateY(-50%)",
                        }}
                        src={"assets/layout/images/check.png"}
                        alt=""
                      />
                    </div>
                  ) : (
                    <Button
                      className="p-button-secondary"
                      label={t("common.sign")}
                      icon="pi pi-user-edit"
                      onClick={() => {
                        Sign({
                          CommandName: "StatementInvoiceBuyer",
                          taxCode: searchParams.get("taxCode"),
                          Id: doc?.id,
                          InvoiceIdArray: [doc?.id],
                        }).then(() => {
                          StatementInvoiceService.getDetail(id, {
                            taxCode: searchParams.get("taxCode"),
                          }).then((res) => {
                            setDoc(res);
                          });
                        });
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
            <Button
              label={t("common.download")}
              onClick={async () => {
                try {
                  const res = await StatementInvoiceService.getPdfUrlV2(
                    doc?.id,
                    { taxCode: searchParams.get("taxCode") },
                  );
                  const pdfUrl = res;
                  const response = await fetch(pdfUrl, { method: "GET" });
                  const blob = await response.blob();
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `${doc?.id}.pdf`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                } catch (error) {
                  alert(t("common.fileDownloadFailed"));
                }
              }}
            />
            {/* {renderSign()} */}
          </div>
          <div className="grid no-gutter border-dashed border-bottom-none border-left-none border-right-none border-top-1">
            <div className="col-4">
              <p className="font-bold underline">
                CÔNG TY TNHH HÓA ĐƠN ĐIỆN TỬ M-INVOICE
              </p>
              <p>
                {t("common.businessRegistrationInfo", {
                  number: "0106026495",
                  authority: "Sở KHĐT Tp. Hà Nội",
                  date: "30/12/2012",
                })}
              </p>
              <p>
                {t("common.address")}: Tòa nhà M-invoice, Số 12-14 Ngõ 269/1 Đường Giáp Bát,
                P. Giáp Bát, Q. Hoàng Mai, Hà Nội
              </p>
              <p>{t("common.phone")}: 0901 80 16 18</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} HỒ CHÍ MINH</p>
              <p>
                {t("common.address")}: Số 2 Đường Nguyễn Thế Lộc, Phường 12, Quận Tân Bình
              </p>
              <p>{t("common.phone")}: 0909 500 126</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} TÂY ĐÔ</p>
              <p>
                {t("common.address")}: Số 03 Quảng Trọng Hoàng, P. Hưng Lợi, Q. Ninh Kiều,TP.
                Cần Thơ
              </p>
              <p>{t("common.phone")}: 0918 640 366</p>
              <Link to="mailto:manhkhan.ct@gmail.com">
                Email: manhkhan.ct@gmail.com
              </Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} HÀ NỘI</p>
              <p>
                {t("common.address")}: Số nhà 27 liền kề 14 KĐT Văn Khê, Quận Hà Đông, Hà Nội
              </p>
              <p>{t("common.phone")}: 0899 90 16 18</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} ĐÀ NẴNG</p>
              <p>{t("common.address")}: Số 100, Lê Tấn Trung, P. Thọ Quang,Quận Sơn Trà</p>
              <p>{t("common.phone")}: 0915 777 591</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} HẢI DƯƠNG</p>
              <p>{t("common.address")}: Khu 1, Phường Thạch Khôi, Tp.Hải Dương</p>
              <p>{t("common.phone")}: 02203 833 666</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} THANH HÓA</p>
              <p>
                {t("common.address")}: Số 68 Trần Bình Trọng, P.Đông Sơn,Thành phố Thanh Hóa
              </p>
              <p>{t("common.phone")}: 0901 80 16 18</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} ĐỒNG NAI</p>
              <p>
                {t("common.address")}: R318, Đường D8, KP 7, P. Thống Nhất,Thành phố Biên Hoà
              </p>
              <p>{t("common.phone")}: 0919 29 22 33</p>
              <Link to="mailto:info@minvoice.vn">Email: info@minvoice.vn</Link>
            </div>
            <div className="col-4">
              <p className="font-bold underline">{t("common.branch")} MIỀN TRUNG</p>
              <p>
                {t("common.address")}: 230/8 Nguyễn Công Trứ, P.An Hải Đông, Q.Sơn Trà, TP.Đà
                Nẵng
              </p>
              <p>{t("common.phone")}: 0982.839.777 - 0905.332.011</p>
              <Link to="mailto:mientrung@minvoice.vn">
                Email: mientrung@minvoice.vn
              </Link>
            </div>
            <div className="col-12 flex align-items-center justify-content-between pt-4 pb-8 border-dashed border-bottom-none border-left-none border-right-none border-top-1">
              <p className="m-0">
                {t("common.copyright", {
                  company: "Công ty TNHH Hóa đơn điện tử M-Invoice",
                })}
              </p>
              <div className="flex align-items-center gap-4">
                <Button
                  className="p-button-outlined p-button-secondary"
                  label="Youtube"
                  icon="pi pi-youtube"
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/channel/UCJd2b57TomvwJOMyXhYVQpQ",
                      "_blank",
                    )
                  }
                />
                <Button
                  className="p-button-outlined p-button-secondary"
                  label="Facebook"
                  icon="pi pi-facebook"
                  onClick={() =>
                    window.open(
                      "https://www.facebook.com/hoadondientu.m.invoice",
                      "_blank",
                    )
                  }
                />
                <Button
                  className="p-button-outlined p-button-secondary"
                  label="0901 80 16 18"
                  icon="pi pi-phone"
                  onClick={() => window.open("tel:0901801618", "_blank")}
                />
                <Button
                  className="p-button-outlined p-button-secondary"
                  label={t("common.socialDemo")}
                  icon="pi pi-youtube"
                  onClick={() =>
                    window.open(
                      "https://www.youtube.com/watch?v=umLV8QLS9A4&feature=youtu.be",
                      "_blank",
                    )
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HDDT;
